import { axiosClient } from "@/shared/api/axios-client";

/** Configuración del prorrateo automático de un tipo y subtipo de solicitud (CA/OC). */
export interface ProrrateoAutomaticoConfig {
  tipoSolicitud: string;
  subtipo: string;
  nombreTipo: string;
  nombreSubtipo: string;
  habilitado: boolean;
  actualizadoAt: string | null;
}

export interface CambiarProrrateoAutomaticoInput {
  tipoSolicitud: string;
  subtipo: string;
  habilitado: boolean;
}

/** Combinaciones configurables (lista corta fija · sin paginar). */
export async function listarProrrateoAutomatico(): Promise<ProrrateoAutomaticoConfig[]> {
  const { data } = await axiosClient.get<ProrrateoAutomaticoConfig[]>("/api/admin/prorrateo-automatico");
  return data;
}

export async function cambiarProrrateoAutomatico(input: CambiarProrrateoAutomaticoInput): Promise<ProrrateoAutomaticoConfig> {
  const { data } = await axiosClient.put<ProrrateoAutomaticoConfig>("/api/admin/prorrateo-automatico", input);
  return data;
}
